function md5(r){var n,t,e,o,u,f,i,a,c,g,C,h=function(r,n){return r<<n|r>>>32-n},l=function(r,n){var t,e,o,u,f;return o=2147483648&r,u=2147483648&n,f=(1073741823&r)+(1073741823&n),(t=1073741824&r)&(e=1073741824&n)?2147483648^f^o^u:t|e?1073741824&f?3221225472^f^o^u:1073741824^f^o^u:f^o^u},d=function(r,n,t,e,o,u,f){return r=l(r,l(l(function(r,n,t){return r&n|~r&t}(n,t,e),o),f)),l(h(r,u),n)},s=function(r,n,t,e,o,u,f){return r=l(r,l(l(function(r,n,t){return r&t|n&~t}(n,t,e),o),f)),l(h(r,u),n)},v=function(r,n,t,e,o,u,f){return r=l(r,l(l(function(r,n,t){return r^n^t}(n,t,e),o),f)),l(h(r,u),n)},m=function(r,n,t,e,o,u,f){return r=l(r,l(l(function(r,n,t){return n^(r|~t)}(n,t,e),o),f)),l(h(r,u),n)},S=function(r){var n,t="",e="";for(n=0;n<=3;n++)t+=(e="0"+(r>>>8*n&255).toString(16)).substr(e.length-2,2);return t};for(a=1732584193,c=4023233417,g=2562383102,C=271733878,n=(t=function(r){for(var n,t=r.length,e=t+8,o=16*((e-e%64)/64+1),u=new Array(o-1),f=0,i=0;i<t;)f=i%4*8,u[n=(i-i%4)/4]=u[n]|r.charCodeAt(i)<<f,i++;return f=i%4*8,u[n=(i-i%4)/4]=u[n]|128<<f,u[o-2]=t<<3,u[o-1]=t>>>29,u}(r=function(r){var n,t,e,o="";n=t=0,e=(r=(r+"").replace(/\r\n/g,"\n").replace(/\r/g,"\n")).length;for(var u=0;u<e;u++){var f=r.charCodeAt(u),i=null;f<128?t++:i=f>127&&f<2048?String.fromCharCode(f>>6|192)+String.fromCharCode(63&f|128):String.fromCharCode(f>>12|224)+String.fromCharCode(f>>6&63|128)+String.fromCharCode(63&f|128),null!=i&&(t>n&&(o+=r.substring(n,t)),o+=i,n=t=u+1)}return t>n&&(o+=r.substring(n,r.length)),o}(r))).length,e=0;e<n;e+=16)o=a,u=c,f=g,i=C,a=d(a,c,g,C,t[e+0],7,3614090360),C=d(C,a,c,g,t[e+1],12,3905402710),g=d(g,C,a,c,t[e+2],17,606105819),c=d(c,g,C,a,t[e+3],22,3250441966),a=d(a,c,g,C,t[e+4],7,4118548399),C=d(C,a,c,g,t[e+5],12,1200080426),g=d(g,C,a,c,t[e+6],17,2821735955),c=d(c,g,C,a,t[e+7],22,4249261313),a=d(a,c,g,C,t[e+8],7,1770035416),C=d(C,a,c,g,t[e+9],12,2336552879),g=d(g,C,a,c,t[e+10],17,4294925233),c=d(c,g,C,a,t[e+11],22,2304563134),a=d(a,c,g,C,t[e+12],7,1804603682),C=d(C,a,c,g,t[e+13],12,4254626195),g=d(g,C,a,c,t[e+14],17,2792965006),a=s(a,c=d(c,g,C,a,t[e+15],22,1236535329),g,C,t[e+1],5,4129170786),C=s(C,a,c,g,t[e+6],9,3225465664),g=s(g,C,a,c,t[e+11],14,643717713),c=s(c,g,C,a,t[e+0],20,3921069994),a=s(a,c,g,C,t[e+5],5,3593408605),C=s(C,a,c,g,t[e+10],9,38016083),g=s(g,C,a,c,t[e+15],14,3634488961),c=s(c,g,C,a,t[e+4],20,3889429448),a=s(a,c,g,C,t[e+9],5,568446438),C=s(C,a,c,g,t[e+14],9,3275163606),g=s(g,C,a,c,t[e+3],14,4107603335),c=s(c,g,C,a,t[e+8],20,1163531501),a=s(a,c,g,C,t[e+13],5,2850285829),C=s(C,a,c,g,t[e+2],9,4243563512),g=s(g,C,a,c,t[e+7],14,1735328473),a=v(a,c=s(c,g,C,a,t[e+12],20,2368359562),g,C,t[e+5],4,4294588738),C=v(C,a,c,g,t[e+8],11,2272392833),g=v(g,C,a,c,t[e+11],16,1839030562),c=v(c,g,C,a,t[e+14],23,4259657740),a=v(a,c,g,C,t[e+1],4,2763975236),C=v(C,a,c,g,t[e+4],11,1272893353),g=v(g,C,a,c,t[e+7],16,4139469664),c=v(c,g,C,a,t[e+10],23,3200236656),a=v(a,c,g,C,t[e+13],4,681279174),C=v(C,a,c,g,t[e+0],11,3936430074),g=v(g,C,a,c,t[e+3],16,3572445317),c=v(c,g,C,a,t[e+6],23,76029189),a=v(a,c,g,C,t[e+9],4,3654602809),C=v(C,a,c,g,t[e+12],11,3873151461),g=v(g,C,a,c,t[e+15],16,530742520),a=m(a,c=v(c,g,C,a,t[e+2],23,3299628645),g,C,t[e+0],6,4096336452),C=m(C,a,c,g,t[e+7],10,1126891415),g=m(g,C,a,c,t[e+14],15,2878612391),c=m(c,g,C,a,t[e+5],21,4237533241),a=m(a,c,g,C,t[e+12],6,1700485571),C=m(C,a,c,g,t[e+3],10,2399980690),g=m(g,C,a,c,t[e+10],15,4293915773),c=m(c,g,C,a,t[e+1],21,2240044497),a=m(a,c,g,C,t[e+8],6,1873313359),C=m(C,a,c,g,t[e+15],10,4264355552),g=m(g,C,a,c,t[e+6],15,2734768916),c=m(c,g,C,a,t[e+13],21,1309151649),a=m(a,c,g,C,t[e+4],6,4149444226),C=m(C,a,c,g,t[e+11],10,3174756917),g=m(g,C,a,c,t[e+2],15,718787259),c=m(c,g,C,a,t[e+9],21,3951481745),a=l(a,o),c=l(c,u),g=l(g,f),C=l(C,i);return(S(a)+S(c)+S(g)+S(C)).toLowerCase()}
var pfandID				= 39446972956836;
var dummyDC				= 41350511657146;
let synergyOption 		= "Variante"; 
let showtextOption 		= "Variante";
let hideOption 			= "Variante";
let defaultChange 		= 0;
var dgsDiscount			= true;
var dgsDiscountDefault 	= 10;

var ua = navigator.userAgent.toLowerCase(); 
let iOS = !window.MSStream && /ipad|iphone|ipod/.test(ua);
let isSafari = (ua.indexOf('safari') != -1 && ua.indexOf('chrome') < 0);
var timerId;
var fbq;
function shareURL(text,url){
  if(navigator.share){
    navigator.share({text:text,url:url});
  }else{
    document.location.href="whatsapp://send?text="+text+" \n"+url;
  }
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  //return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
}
function getKeyByValue(arr,value){
  for(var i=0; i < arr.length; i++){
    if(arr[i] == value) return i; break;
  }
}
function formatNumber(amount, decimalCount = 2, decimal = ",", thousands = "."){
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    const negativeSign = amount < 0 ? "-" : "";
    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;
    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    //console.log(e)
  }
};
function formatDecimalInt(menge, d=",", t="."){
  menge = parseFloat(menge);
  if(menge < 10){
    if(Math.trunc(menge) != menge.toFixed(1)){
      return formatNumber(menge.toFixed(1),1,d,t);
    }else{
      return Math.round(menge);
    }
  }else{
    return formatNumber(menge,0,d,t);
  }
}
function numticker(id){
  var ticker	= window['numticker_'+id];
  if(ticker){clearInterval(ticker);}
  var last	= $("#"+id).attr('data-last');
  var last 	= (last == "" || last === undefined) ? 0 : last;
  var last 	= parseFloat(last);
  var score	= parseFloat($("#"+id).attr('data-score'));
  var time	= parseInt($("#"+id).attr('data-time'));
  var blocks	= time / 100
  var steps	= (last <= score) ? ((score - last) / blocks) : ((last - score) / blocks);
  var counter	= last;
  var ticker	= setInterval(function(){
    if(last <= score){
      counter = counter + steps;
      counter = (counter >= score) ? score : counter;
    }else{
      counter = counter - steps;
      counter = (counter <= score) ? score : counter;
    }
    if(counter == score){clearInterval(ticker);}
    $("#"+id).attr('data-last',counter);
    var return_counter = formatDecimalInt(counter);
    $("#"+id).text(return_counter);
  }, 100);
}
function soonCountdown(container,trigger){
  var current_date 	= Math.round(new Date().getTime() / 1000);
  var launch_date 	= parseInt(trigger);
  var difference 	= parseInt(launch_date) - parseInt(current_date);
  var textbased 	= "";
  //console.log(container,difference);
  if(difference <= 0){
    $(container).hide();
  }else{
    // Tage
    var tage_decimal 	= parseInt(difference) / (60*60*24);
    var tage_floor 		= Math.floor(tage_decimal);
    var tage_print 		= (parseInt(tage_floor) < 10) ? "0"+tage_floor : tage_floor;
    var tage_print 		= tage_print.toString();
    var difference 		= parseInt(difference) - (parseInt(tage_floor)*60*60*24);
    var textbased 		= tage_print;
    $(container).find("[data-countdown='d1']").text(tage_print.slice(0,1));
    $(container).find("[data-countdown='d2']").text(tage_print.slice(1,2));
    if(tage_print == 0){
      $(container).find("[data-countdown='d2']").parent().css("opacity",0.6);
    }
    // Stunden
    var stunden_decimal = parseInt(difference) / (60*60);
    var stunden_floor 	= Math.floor(stunden_decimal);
    var stunden_print 	= (parseInt(stunden_floor) < 10) ? "0"+stunden_floor : stunden_floor;
    var stunden_print 	= stunden_print.toString();
    var difference 		= parseInt(difference) - (parseInt(stunden_floor)*60*60);
    var textbased 		= textbased + ":" + stunden_print;
    $(container).find("[data-countdown='h1']").text(stunden_print.slice(0,1));
    $(container).find("[data-countdown='h2']").text(stunden_print.slice(1,2));
    if(tage_print == 0 && stunden_print == 0){
      $(container).find("[data-countdown='h2']").parent().css("opacity",0.6);
    }
    // Minuten
    var minuten_decimal = parseInt(difference) / (60);
    var minuten_floor 	= Math.floor(minuten_decimal);
    var minuten_print 	= (parseInt(minuten_floor) < 10) ? "0"+minuten_floor : minuten_floor;
    var minuten_print 	= minuten_print.toString();
    var difference 		= parseInt(difference) - (parseInt(minuten_floor)*60);
    var textbased 		= textbased + ":" + minuten_print;
    $(container).find("[data-countdown='m1']").text(minuten_print.slice(0,1));
    $(container).find("[data-countdown='m2']").text(minuten_print.slice(1,2));
    if(tage_print == 0 && stunden_print == 0 && minuten_print == 0){
      $(container).find("[data-countdown='m2']").parent().css("opacity",0.6);
    }
    // Sekunden
    var sekunden_decimal = parseInt(difference);
    var sekunden_floor 	= Math.floor(sekunden_decimal);
    var sekunden_print 	= (parseInt(sekunden_floor) < 10) ? "0"+sekunden_floor : sekunden_floor;
    var sekunden_print 	= sekunden_print.toString();
    var difference 		= parseInt(difference) - parseInt(sekunden_floor);
    var textbased 		= textbased + ":" + sekunden_print;
    $(container).find("[data-countdown='s1']").text(sekunden_print.slice(0,1));
    $(container).find("[data-countdown='s2']").text(sekunden_print.slice(1,2));
    $(container).find("[data-type='countdown_text']").text(textbased);
    // Repeat
    setTimeout(function(){
      soonCountdown(container,trigger);
    }, 1000);
  }
}
function dgsSwitchAction(container,group,position){
  var breakpoint 	= parseInt(768);
  var optiontouch 	= "change-all";
  var optionclick 	= "change-all";
  if($(window).width() < breakpoint){
    if(optiontouch == 'change-img'){
      dgsSwitchVariant(container,group,"change","change-img",1,0,position);
    }else if(optiontouch == 'change-all'){
      dgsSwitchVariant(container,group,"change","change-all",1,1,position);
    }else if(optiontouch == 'link'){
      dgsSwitchVariant(container,group,"change","link",0,0,position);
    }else{
      dgsSwitchVariant(container,group,"change","none",0,0,position);
    }
  }else{
    if(optionclick == 'change-img'){
      dgsSwitchVariant(container,group,"change","change-img",1,0,position);
    }else if(optionclick == 'change-all'){
      dgsSwitchVariant(container,group,"change","change-all",1,1,position);
    }else if(optionclick == 'link'){
      dgsSwitchVariant(container,group,"change","link",0,0,position);
    }else{
      dgsSwitchVariant(container,group,"change","none",0,0,position);
    }
  }
}
function updateHistoryState(variant,event){
  if(variant !== undefined){
    var path = "";
    var newurl = path + "?variant=" + variant;
    var $splitter = $(".dgs-product-option[splitter]");
    var filter = $splitter.attr("option-split");
    if(parseInt(filter) == 1){
      var newurl = newurl + "?show=vegan";
    }
    if(event == "load"){
      //window.history.pushState({}, null, newurl);
    }else{
      window.history.replaceState({}, null, newurl);
    }
  }
}
function dgsSwitchBundleVariant(container){
  var $container		= $("div[data-container='"+container+"']");
  var $option 			= $container.find("*.dgs-product-option-select");
  var optionValue	 	= $option.val();
  var $variants 		= $container.find("select[data-type='product-variant'][data-group='bundle']");
  var $variant 			= $variants.find("option[value='"+optionValue+"']");
  var $image			= $container.find("*[data-type='product-image']");
  $variant.prop("selected", true);
  var variant_url 		= $variant.attr("data-url");
  $container.find("*[data-type='product-link']").attr("href",variant_url);
  var variant_pre 		= $variant.attr("data-pre");
  var variant_img 		= $variant.attr("data-img");
  $image.css("backgroundImage","url('"+variant_pre+"')");
  $('<img/>').attr('src',variant_img).on('load', function() {
    $(this).remove();
    $image.attr("data-pre",variant_pre).attr("data-img",variant_img)
    .css("backgroundImage","url('"+variant_img+"')");
  });
  if($(".dgs-product-bundle").length){ updateBundleVariants(); }
}
function dgsSwitchSmartselect(container){
  var group				= "details";;
  var group				= (container.includes("modal")) ? "modal" : group;
  //console.log("group",group);
  var $container		= $("div[data-container='"+container+"']");
  var $variants 		= $container.find("select[data-type='product-variant'][data-group='"+group+"']");
  var $smartselect		= $container.find("select.dgs-product-option-select[data-type='product-option'][data-group='smartselect']");
  var variant_id 		= $smartselect.val();
  $variants.val(variant_id);
  var $variant 			= $variants.find("option[value='"+variant_id+"']");
  var option1			= $variant.attr("data-option1");
  $container.find("input[data-option='1'][data-group='"+group+"'][value='"+option1+"']").prop("checked", true);
  var option2			= $variant.attr("data-option2");
  $container.find("input[data-option='2'][data-group='"+group+"'][value='"+option2+"']").prop("checked", true);
  var option3			= $variant.attr("data-option3");
  $container.find("input[data-option='3'][data-group='"+group+"'][value='"+option3+"']").prop("checked", true);
  setTimeout(function () { dgsSwitchVariant(container,group,"change"); }, 10);
}
function is_cached(src) {
  var image = new Image();
  image.src = src;
  return image.complete;
}
function dgsSwitchVariant(container,group,event,action,image = 1,price = 1,rep_option = 0,rep_value = ""){
  var breakpoint 	= parseInt(768);
  var productSelectedOptions = {};
  //console.log(container,group);
  var $container	= $("div[data-container='"+container+"']");
  var $variants 	= $container.find("select[data-type='product-variant'][data-group='"+group+"']");
  var $smartselect	= $container.find("select.dgs-product-option-select[data-type='product-option'][data-group='smartselect']");
  var productID 	= $variants.attr("product-id");
  var handle		= $variants.attr("data-handle");
  var colsplit		= $variants.attr("data-colsplit");
  var name_option1	= $variants.attr("data-option1");
  var name_option2	= $variants.attr("data-option2");
  var name_option3	= $variants.attr("data-option3");
  var $options 		= $container.find("*[data-type='product-option'][data-group='"+group+"']");
  var $image		= $container.find("*[data-type='product-image']");
  var $prices		= $container.find("*[data-type='product-price']");
  var $unitprice	= $container.find("*[data-type='product-unitprice']");
  var synergyValue 	= "";
  var showtextValue = "";
  $options.each(function(){
    var option 	= $(this).attr("data-option");
    if($(this).attr("type") == "radio"){
      var name 		= $(this).attr("name");
      if(rep_value != "" && parseInt(option) == parseInt(rep_option)){
        var value 	= rep_value;
      }else{
        var value 	= $container.find("input[data-group='"+group+"'][name='"+name+"']:checked").val();
      }
    }else{
      var value 	= $(this).val();
    }
    productSelectedOptions[option] = value;
  }).promise().done(function(){
    var option1 = (productSelectedOptions[1] !== undefined) ? productSelectedOptions[1] : "";
    var option2 = (productSelectedOptions[2] !== undefined) ? productSelectedOptions[2] : "";
    var option3 = (productSelectedOptions[3] !== undefined) ? productSelectedOptions[3] : "";
    // synergyOption
    if(name_option1 == synergyOption){ synergyValue = option1; }
    else if(name_option2 == synergyOption){ synergyValue = option2; }
    else if(name_option3 == synergyOption){ synergyValue = option3; }
    // showtextOption
    if(name_option1 == showtextOption){ showtextValue = option1; }
    else if(name_option2 == showtextOption){ showtextValue = option2; }
    else if(name_option3 == showtextOption){ showtextValue = option3; }
    //console.log(option1,option2,option3);
    $variant 	= $variants.find("option[data-option1='"+option1+"'][data-option2='"+option2+"'][data-option3='"+option3+"']");
    if($variant.val() !== undefined && $variant.val() != ""){
      $variant.prop("selected", true);
      var variant_id 		= $variant.val();
      current_variant = variant_id;
      if($smartselect.length){ $smartselect.val(variant_id); }
      if(typeof ttq !== "undefined"){ ttq.track('ViewContent',{ content_id:variant_id });}
      if(group == "details" && (event == "change" || event == "load")){ updateHistoryState(variant_id,event);}
      var variant_url 		= $variant.attr("data-url");
      if(colsplit !== ""){
        var requestPath		= $('body').attr("current-path");
        //console.log("colsplit",colsplit,requestPath);
        var isCollection	= (requestPath.includes('collection')) ? true : false;
        var collectionHandle = requestPath.split('/').pop();
        //console.log("colsplit",isCollection,collectionHandle);
        variant_url 	= (variant_url.includes('?')) ? variant_url + "&show=vegan" : variant_url + "?show=vegan";
      }
      var variant_pre 		= $variant.attr("data-pre");
      var variant_img 		= $variant.attr("data-img");
      var variant_imgid		= $variant.attr("data-imgid");
      var variant_price 	= $variant.attr("data-price");
      var variant_unitprice = $variant.attr("data-unitprice");
      var variant_compare 	= $variant.attr("data-compare");
      var variant_sale 		= $variant.attr("data-sale");
      var variant_soldout	= $variant.attr("data-soldout");
      var variant_vegan		= parseInt($variant.attr("data-vegan"));
      var variant_subtitle	= $variant.attr("data-subtitle");
      var variant_filling	= $variant.attr("data-filling");
      //console.log(variant_id,variant_img);
      dgsSwitchSoldout(container,group,rep_option);
      if(group != "modal" || 1 == 1){
        $("#dgs-template-"+container).attr("data-variant",variant_id);
        $container.find("*[data-type='product-link']").attr("href",variant_url);
      }
      if(action == "link"){
        loading(); window.parent.location.href = variant_url;
      }else if(event != "hover" || (event == "hover" && $(window).width() >= breakpoint)){
        if(variant_vegan == 1){
          showtextValue = showtextValue.replace("vegan","").replace("Vegan","").replace("VEGAN","").trim();
          showtextValue = showtextValue + " (vegan)";
        }
        dgsSwitchShowtext(showtextValue);
        if(group == "details"){
          var $descContainer = $(".dgs-details-pages-content[data-tab='tab-desc']");
          if($descContainer.length){
            var desc_default = renderTemplate("dgs-template-"+productID,".dgs-details-desc[data-variant='default']","inner");
            var desc_variant = renderTemplate("dgs-template-"+productID,".dgs-details-desc[data-variant='"+variant_id+"']","inner");
            if(!desc_variant){ $descContainer.empty().append(desc_default); }
            else{ $descContainer.empty().append(desc_variant); }
          }
          if($(".dgs-block-product_content").length){
            $(".dgs-block-product_content").text(variant_subtitle);
          }
          if($(".dgs-block-product_filling").length){
            $(".dgs-block-product_filling").text(variant_filling);
          }
          dgsSwitchConnections(handle,synergyValue);
          dgsSwitchAnalysen(variant_id);
          dgsSwitchIngredients(variant_id);
        }
        if(image == 1){
          //console.log("image chached",variant_img,is_cached(variant_img));
          /*
          if(event != "load"){ $image.css("backgroundImage","url('"+variant_pre+"')"); }
          $('<img/>').attr('src',variant_img).on('load', function() {
            $(this).remove();
            $image.attr("data-pre",variant_pre).attr("data-img",variant_img)
            .css("backgroundImage","url('"+variant_img+"')");
          });
          */
          $image.attr("data-pre",variant_pre).attr("data-img",variant_img)
          .css("backgroundImage","url('"+variant_img+"')");
          if($("*[data-type='optionsplit']").length && group == "details"){
            var optionId = parseInt($("*[data-type='product-image']").attr("data-option"));
            var optionValue = option1;
            if(optionId == 2){ var optionValue = option2; }
            else if(optionId == 3){ var optionValue = option3; }
            $("*[data-type='optionsplit']").attr("data-show",0);
            $("*[data-type='optionsplit'][data-split='"+optionValue+"']").attr("data-show",1);
            $container.find(".dgs-details-media-thumb").removeClass("active");
            $container.find(".dgs-details-media-thumb[data-thumb='"+variant_imgid+"']").addClass("active");
          }
          if($(".dgs-details-background").length && group == "details"){
            $("div[data-type='details-background']").attr("data-show",0);
            var gradientColor 	= $("div[data-type='details-background'][data-variant='"+variant_id+"']").attr("data-gradient");
            var fadeColor 		= $("div[data-type='details-background'][data-variant='"+variant_id+"']").attr("data-fade");
            if(gradientColor != ""){ 
              $(".dgs-details-background-gradient").hide();
              $(".dgs-details-background-gradient").css("background-image","radial-gradient(ellipse at left bottom, "+gradientColor+" 25%, transparent 80%), radial-gradient(ellipse at right bottom, "+fadeColor+" 45%, transparent 75%)");
              $(".dgs-details-background-gradient").fadeIn(500);
              $(".dgs-details-background-fader").css("background","linear-gradient(25deg, "+fadeColor+" 5%, rgba(255,255,255,0) 35%)");
            }
            $("div[data-type='details-background'][data-variant='"+variant_id+"']").attr("data-show",1);
          }
        }
        if(price == 1){
          $prices.attr("data-sale",variant_sale);
          $prices.find(".regular").text(variant_price+" €*");
          $prices.find(".compare").text(variant_compare+" €*");
          if(variant_unitprice != ""){ $unitprice.text(variant_unitprice).show(); }
          else{ $unitprice.hide(); }
          $container.find(".dgs-block-product_badge-sale").attr("data-show",variant_sale);
          $container.attr("data-soldout",variant_soldout);
          $container.find(".dgs-block-product_badge-soldout").attr("data-show",variant_soldout);
          $container.find(".dgs-block-product-buttons").attr("data-soldout",variant_soldout);
          
          var discount_cookie 		= getCookie("discount_code");
          if(discount_cookie !== "undefined" && discount_cookie != ""){
            var checkCode 			= checkDiscountCode(discount_cookie);      	
            if(checkCode != false){
              var newPrice		= Math.round(parseFloat(variant_price.replace(",",".")) * 100).toString();
              console.log(checkCode,productID,"",newPrice,group);
              var withcode		= discountedPrice(productID,"",newPrice);
              var withcode 		= parseInt(withcode) / 100;
              var withcode 		= formatNumber(withcode, 2, ",", ".");
              if(withcode){
                //$container.css("display","flex");
                $container.find("*[data-type='discount-price']").css("display","flex");
                if(group == "modal"){
                  var textline		= discountedPrice(productID,"",newPrice,1,"textline","discountBadge");
                  $container.find("*[data-type='discount-price']").html(textline);
                }else{
                  $container.find("*[data-type='product-price-withcode']").text(withcode+" €*");
                  $container.find("*[data-type='discount-code']").text(checkCode).attr("textline",textline);
                }
                $container.find("*[data-type='product-price']").parent().attr("data-withcode",1);
              }
            }
          }
          
        }
      }
      if($(".dgs-product-bundle").length && event != "hover"){ updateBundleVariants(); }
    }else{ dgsSwitchSoldout(container,group,rep_option); }
  });
}
function dgsSwitchSoldout(container,group,rep_option){
  //console.log("dgsSwitchSoldout",rep_option);
  var $container	= $("div[data-container='"+container+"']");
  var $variants 	= $container.find("select[data-type='product-variant'][data-group='"+group+"']");
  //var $option1 		= $variants.find("option:selected").attr("data-option1");
  //var $option2 		= $variants.find("option:selected").attr("data-option2");
  //var $option3 		= $variants.find("option:selected").attr("data-option3");
  var $options 		= $container.find("*[data-type='product-option'][data-group='"+group+"']");
  var $option1 		= $container.find("[data-type='product-option'][data-group='"+group+"'][data-option='1']:checked").val();
  if(typeof $option1 === "undefined"){ $option1 = ""; }
  var $option2 		= $container.find("[data-type='product-option'][data-group='"+group+"'][data-option='2']:checked").val();
  if(typeof $option2 === "undefined"){ $option2 = ""; }
  var $option3 		= $container.find("[data-type='product-option'][data-group='"+group+"'][data-option='3']:checked").val();
  if(typeof $option3 === "undefined"){ $option3 = ""; }
  //var $others 		= $options.not("[data-option='"+rep_option+"']");
  var $others 		= $options.not("[option-name='Größe']");
  //console.log($option1,$option2,$option3);
  $others.each(function(){
    var option 	= parseInt($(this).attr("data-option"));
    var value 	= $(this).val();
    if(option == 1){
      $variant 	= $variants.find("option[data-option1='"+value+"'][data-option2='"+$option2+"'][data-option3='"+$option3+"']");
    }else if(option == 2){
      $variant 	= $variants.find("option[data-option1='"+$option1+"'][data-option2='"+value+"'][data-option3='"+$option3+"']");
    }else if(option == 3){
      $variant 	= $variants.find("option[data-option1='"+$option1+"'][data-option2='"+$option2+"'][data-option3='"+value+"']");
    }
    //console.log($variant.val());
    // Soldout-Status aktualisieren
    if($variant.length){
      var variant_soldout	= $variant.attr("data-soldout");
      if(parseInt(variant_soldout) > 0){ $(this).attr("soldout",""); $(this).filter("[option-name='Variante']").parent().css("order","9999"); }
      else{ $(this).removeAttr("soldout"); $(this).parent().css("order",""); }
    }else{ $(this).removeAttr("soldout"); $(this).parent().css("order",""); }
    // Lösche Varianten, die es nicht gibt
    if($variant.length){
      $(this).parent().show();
    }else{
      if(group != "smartselect"){ $(this).parent().hide(); }
    }
  }).promise().done(function(){
    if($(".dgs-section-details-offer").length && group == "details"){
      var $clipstatus 		= $(".dgs-product-option[data-option='"+synergyOption+"']").find("ul").attr("data-clip");
      if($clipstatus == "1"){ resizeClipoption(0); }
      else{ resizeClipoption(1); }
    }
  });
}
function dgsSwitchShowtext(option){
  if(option != ""){
    $(".dgs-section-dgs-product-details").find("span[showtextOption='"+showtextOption+"']").text(option);
  }
}
function dgsSwitchConnections(handle,option){
  var $synergys 		= $("*[data-type='product-synergy']");
  $synergys.each(function(){
    var $variant		= "";
    var $variants 		= $(this).find("select[data-type='product-variant']");
    var $image			= $(this).find("*[data-type='product-image']");
    var name_option1	= $variants.attr("data-option1");
    var name_option2	= $variants.attr("data-option2");
    var name_option3	= $variants.attr("data-option3");
    if(name_option1 == synergyOption){
      var $selected 	= $variants.find("option[data-option1='"+option+"']").first();
      if($selected.length){ 
        $variant = $selected.val();
        $selected.prop("checked", true);
      }
    }else if(name_option2 == synergyOption){ 
      var $selected 	= $variants.find("option[data-option2='"+option+"']").first();
      if($selected.length){ 
        $variant = $selected.val();
        $selected.prop("checked", true);
      }
    }else if(name_option3 == synergyOption){ 
      var $selected 	= $variants.find("option[data-option3='"+option+"']").first();
      if($selected.length){ 
        $variant = $selected.val();
        $selected.prop("checked", true);
      }
    }
    if($variant != ""){
      var variant_url 		= $selected.attr("data-url");
      var variant_pre 		= $selected.attr("data-pre");
      var variant_img 		= $selected.attr("data-img");
      $(this).find("*[data-type='product-link']").parent().parent().show();
      var getParameter_show 	= findGetParameter("show");
      if(getParameter_show == "vegan"){
        variant_url 	= (variant_url.includes('?')) ? variant_url + "&show=vegan" : variant_url + "?show=vegan";
      }else{
        variant_url 	= variant_url.replace("&show=vegan","");
        variant_url 	= variant_url.replace("?show=vegan","");
      }
      $(this).find("*[data-type='product-link']").attr("href",variant_url);
      $image.css("backgroundImage","url('"+variant_pre+"')");
      $('<img/>').attr('src',variant_img).on('load', function() {
        $(this).remove();
        $image.attr("data-pre",variant_pre).attr("data-img",variant_img)
        .css("backgroundImage","url('"+variant_img+"')");
      });
    }else{
      $(this).find("*[data-type='product-link'][data-addon]").parent().parent().hide();
    }
  });
}
function dgsSwitchAnalysen(variant_id){
  var $synergys 		= $("*[data-type='analyse-synergy']");
  $synergys.each(function(){
    var analyseVariante 	= $(this).attr("data-variante");
    //console.log("synergy",analyseVariante );
    if(analyseVariante == variant_id){
      $(this).attr("data-show",1);
    }else{
      $(this).attr("data-show",0);
    }
  });
}
function dgsSwitchIngredients(variant_id){
  var $synergys 		= $("*[data-type='ingredients-synergy']");
  $synergys.each(function(){
    var ingredientsVariante 	= $(this).attr("data-variante");
    //console.log("synergy",analyseVariante );
    if(ingredientsVariante == variant_id){
      $(this).attr("data-show",1);
    }else{
      $(this).attr("data-show",0);
    }
  });
}
function toggleOptionFilter(){
  var $splitter = $(".dgs-product-option[splitter]");
  var filter = $splitter.attr("option-split");
  if(parseInt(filter) == 1){
    $splitter.attr("option-split",0);
  }else{
    $splitter.attr("option-split",1);
  }
  if($(".dgs-section-details-offer").length){
    var $clipstatus 		= $(".dgs-product-option[data-option='"+synergyOption+"']").find("ul").attr("data-clip");
    if($clipstatus == "1"){ resizeClipoption(0); }
    else{ resizeClipoption(1); }
  }
  updateHistoryState(current_variant,"change");
  return false;
}
function renderTemplate(tpl,selector,html = "outer"){
  if($('#'+tpl).length){
    var template 			= document.querySelector('#'+tpl);
    if(template.content.querySelector(selector)){
      if(html == "inner"){
        var selector 	= template.content.querySelector(selector).innerHTML;
      }else{
        var selector 	= template.content.querySelector(selector).outerHTML;
      }
      return selector;
    }else{ return false; }
  }
}
function openModal(template,selector,type,fullscreen = 0){
  var modalcontent	= renderTemplate(template,selector);
  if(fullscreen == 1){ $(".dgs-modal-container").css("height","100%");}
  if(type == "cart-gifts"){ $(".dgs-modal-container").attr("max-width","L"); }
  else{ $(".dgs-modal-container").removeAttr("max-width"); }
  $(".dgs-modal-content").empty().html(modalcontent).promise().done(function(){
    if(type == "product-options"){
      var id = template.replace("dgs-template-","");
      var variant_id 	= $('#'+template).attr("data-variant");
      var $selected 	= $("[data-container='"+id+"']").find("[data-type='product-variant'][data-group='block']").find("option[value='"+variant_id+"']");
      var option1 	= $selected.attr("data-option1");
      var option2 	= $selected.attr("data-option2");
      var option3 	= $selected.attr("data-option3");
      //console.log(id,type,variant_id,option1,option2,option3);
      var $container	= $("div[data-container='"+id+"-modal']");
      var selected_variant = $container.find("[data-type='product-variant'][data-group='modal']").find("option[value='"+variant_id+"']").prop("selected", true);

      $container.find("input[type='radio'][data-type='product-option'][data-option='1'][data-group='modal'][value='"+option1+"']").prop("checked", true);
      $container.find("select[data-type='product-option'][data-option='1'][data-group='modal']").find("option[value='"+option1+"']").prop("selected", true);
      $container.find("input[type='text'][data-type='product-option'][data-option='1'][data-group='modal']").val(option1);

      $container.find("input[type='radio'][data-type='product-option'][data-option='2'][data-group='modal'][value='"+option2+"']").prop("checked", true);
      $container.find("select[data-type='product-option'][data-option='2'][data-group='modal']").find("option[value='"+option2+"']").prop("selected", true);
      $container.find("input[type='text'][data-type='product-option'][data-option='2'][data-group='modal']").val(option2);

      $container.find("input[type='radio'][data-type='product-option'][data-option='3'][data-group='modal'][value='"+option3+"']").prop("checked", true);
      $container.find("select[data-type='product-option'][data-option='3'][data-group='modal']").find("option[value='"+option3+"']").prop("selected", true);
      $container.find("input[type='text'][data-type='product-option'][data-option='3'][data-group='modal']").val(option3);
      /*
    }else if(type == "cart-discount"){
      var discountArr = checkDiscountCode();
      if(discountArr !== false){
        if($("input[data-type='dgs-discount-input'][data-content='header']").length){
          $("input[data-type='dgs-discount-input'][data-content='header']").val(discountArr[0]);
          $(".dgs-cart-discount-remove").css("display","flex");
        }
      }else{
        $(".dgs-modal-header-discount > span[discount-text]").show();
      }
      */
    }else if(type == "newsletter-modal"){
      var dataFromEmail0 = $("input[datafrom][data-transfer='email']").eq(0).val();
      var dataFromEmail1 = $("input[datafrom][data-transfer='email']").eq(1).val();
      var dataFromEmail = (dataFromEmail0 != "") ? dataFromEmail0 : dataFromEmail1;
      //console.log("EMAIL",dataFromEmail);
      $("input[datato][data-transfer='email']").val(dataFromEmail);
    }
    closeCartbar();
    $('body').css('overflow', 'hidden');
    $(".dgs-modal").fadeIn();
    $(".dgs-modal").attr("data-open",1);
    $(".dgs-modal[data-editor='0'] .dgs-modal-bg").click(function(){closeModal();});
    $(".dgs-modal[data-editor='0'] .dgs-modal-closer").click(function(){closeModal();});
  });
}
function closeModal(){
  defaultChange = 0;
  $('body').css('overflow', 'auto');
  $(".dgs-modal").attr("data-open",0);
  $(".dgs-modal").hide().attr("data-editor",0);
  $(".dgs-modal-container").removeAttr("style");
  $(".dgs-modal-content").empty();
  $(".dgs-modal-bg, .dgs-modal-closer").unbind();
  $(".dgs-cartbar-item").attr("dgs-viewport","false");
  if(timerId){clearInterval(timerId);}
}
function dgsChangeImage(event,container,slider,slide,slide_id,action){
  var breakpoint 	= parseInt(768);
  var $container	= $("div[data-container='"+container+"']");
  var $slider		= $container.find("*[data-type='"+slider+"']");
  var $slide		= $container.find("*[data-type='"+slide+"'][data-slide='"+slide_id+"']");
  var slide_pre		= $slide.attr("data-pre");
  var slide_img		= $slide.attr("data-img");
  if(event != "hover" || (event == "hover" && $(window).width() >= breakpoint)){
    if(action == "over"){
      $slider.css("backgroundImage","url('"+slide_pre+"')");
      $('<img/>').attr('src',slide_img).on('load', function() {
        $(this).remove();
        $slider.css("backgroundImage","url('"+slide_img+"')");
      });
    }else{
      $slider.css("backgroundImage","url()");
    }
  }
}
function openCartbar(load = 0){
  var open = $("body").attr("data-cartbar");
  if(load == 1){
    $(".dgs-cartbar").find(".dgs-cartbar-list").attr("loadercover");
    loadContent('dgs-cart-sidebar','shopify-section-dgs-cart-sidebar');
  }else{
    closeModal();
    closeCartToast();
    $('body').css('overflow', 'hidden');
    var header_height = $("header").height();
    $(".dgs-cartbar-topspace").css("height",header_height+"px");
    $("body").attr("data-cartbar",1);
    $(".dgs-darker").fadeIn();
    $(".dgs-cartbar-closer").addClass("dgs-cartbar-closer-show");
    if(open == 1){
      $(".dgs-cartbar-item").attr("dgs-block","true");
      //$(".dgs-cartbar-item").removeAttr("dgs-effect").removeAttr("dgs-viewport").removeAttr("dgs-auto")
      //.removeAttr("dgs-timing").removeAttr("dgs-duration").removeAttr("dgs-delay");
    }else{
      $(".dgs-cartbar-item").attr("dgs-viewport","true");
      $(".dgs-cartbar-empty").find("*[dgs-viewport]").attr("dgs-viewport","true");
    }
    configURL("change","add","open","cartbar");
  }
}
function closeCartbar(){
  $('body').css('overflow', 'auto');
  $("body").attr("data-cartbar",0);
  $(".dgs-darker").fadeOut();
  $(".dgs-cartbar-closer").removeClass("dgs-cartbar-closer-show");
  $(".dgs-cartbar-item").attr("dgs-viewport","false");
  $(".dgs-cartbar-empty").find("*[dgs-viewport]").attr("dgs-viewport","false");
  $(".dgs-cartbar-item").attr("dgs-block","false");
  configURL("change","remove","open","cartbar");
}
function toggleCartbar(load = 0){
  var cartbar_open = $("body").attr("data-cartbar");
  if(cartbar_open == 1){
    closeCartbar();
  }else{
    openCartbar(load);
  }
}
function openCartToast(){
  $(".dgs-carttoast").removeAttr("style");
  let carttoast = parseInt($("body").attr("data-carttoast"));
  let cloned 	= parseInt($("body").attr("data-cloned"));
  if(carttoast == 1 && cloned == 1){
    if(toastTimeout){clearTimeout(toastTimeout);}
    toastTimeout = setTimeout(function(){
      closeCartToast();
    }, 2500);
  }
}
function closeCartToast(){
  if(toastTimeout){clearTimeout(toastTimeout);}
  $("body").attr("data-carttoast",0);
  $("body").attr("data-cloned",0); 
}
function openInfoToast(type,text){
  $(".dgs-infotoast").removeAttr("style");
  let infotoast = parseInt($("body").attr("data-infotoast"));
  if(infotoast != 1){
    $(".dgs-infotoast-msg").text(text);
    $("body").attr("data-infotoast",1);
    if(toastTimeout){clearTimeout(toastTimeout);}
    toastTimeout = setTimeout(function(){
      closeInfoToast();
    }, 2500);
  }
}
function closeInfoToast(){
  if(toastTimeout){clearTimeout(toastTimeout);}
  $("body").attr("data-infotoast",0);
}
function checkDiscountCode(code){
  var discounts 	= $("[data-type='discount-input']").attr("data-codes");
  //console.log(code,discounts);
  if(discounts !== undefined){
    var discountsArr	= discounts.split("|");
    var code 			= (typeof code !== "undefined") ? code : getCookie("discount_code");
    var code 			= (code) ? code.toUpperCase() : "";
    //console.log(code,discountsArr);
    if(discountsArr.includes(code)){ return code; }
    else{ return false; }
  }else{ return false; }
}
function getDiscountPrice(){
  var discount_cookie 	= getCookie("discount_code");
  if(discount_cookie !== "undefined" && discount_cookie != ""){
    var checkCode 		= checkDiscountCode(discount_cookie);      	
    if(checkCode != false){
      var $item 		= $("body").find("*[data-type='discount-price']");
      $item.each(function(){
        var product 	= $(this).attr("data-product");
        var tags 		= $(this).attr("data-tags");
        var price 		= $(this).attr("data-price");
        var withcode	= discountedPrice(product,tags,price);
        var withcode 	= parseInt(withcode) / 100;
        var withcode 	= formatNumber(withcode, 2, ",", ".");
        //var textline	= discountedPrice(product,tags,price,1,"textline");
        tags = (tags) ? tags : [];
        if(withcode && !tags.includes("nodiscount")){
          $(this).find("*[data-type='product-price-withcode']").text(withcode+" €*");
          $(this).find("*[data-type='discount-code']").text(checkCode);
          $(this).css("display","flex");
          $(this).parent().find(".dgs-block-product_price").attr("data-withcode",1);
          // $(this).html(textline);
        }
      });
    }
  }
}
function getCurrentRedirect(){
  var currentURL	 	= window.location.href;
  var uselessURL	  	= window.location.protocol + '//' + window.location.hostname;
  var currentRedirect 	= currentURL.replace(uselessURL,"");
  return currentRedirect;
}
function removeDiscountCode(content){
  var $container		= $("*[data-discount='"+content+"']");
  var code = $container.find("input[data-type='dgs-discount-input']").val();
  if(code != ""){
    $(".dgs-cartbar-button").prop("disabled", true);
    $(".dgs-cartbar-cart").attr("loadercover","");
    document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    var shopURL		= window.location.protocol + '//' + window.location.hostname;
    var currentURL 	= getCurrentRedirect();  
    var currentURL 	= currentURL.replace("&open=cartbar","").replace("?open=cartbar",""); 
    var redirectURL = shopURL+currentURL;
    var open = $("body").attr("data-cartbar");
    if(parseInt(open) == 1){ sessionStorage.setItem("dgs_open","cartbar"); }
    //var redirectURL = (currentURL.includes("?")) ?  redirectURL+"&open=cartbar" : redirectURL+"?open=cartbar";
    if(window.location != window.parent.location){ window.parent.location.href = redirectURL; }
    else{ window.location.href = redirectURL; }
  }
}
function changeDiscountCode(content,code){
  var $container		= $("*[data-discount='"+content+"']");
  var codeInput 		= $container.find("input[data-type='dgs-discount-input']").val();
  var code 				= (code) ? code : codeInput;
  var code 				= code.trim().toUpperCase();
  var checkCode 		= checkDiscountCode(code);
  var discount_cookie 	= getCookie("discount_code");
  var errorAttr 		= $container.attr("error");
  if(code == ""){ 
    $container.find("error").text("Code darf nicht leer sein!");
    $container.attr("error",1);
  }else if(code == discount_cookie){ 
    $container.find("error").text("Dieser Code wird bereits verwendet!");
    $container.attr("error",1);
  }else if(checkCode !== false){ successDiscountCode(content,code); }
  else{ errorDiscountCode(content,code); }
}
function errorDiscountCode(content,code){
  var $container		= $("*[data-discount='"+content+"']");
  var msg = $container.find("error").attr("msg");
  var error = msg.replace("[code]","<b>"+code+"</b>");
  $container.find("error").html(error);
  $container.attr("error",1).find(".dgs-cart-discount-remove").hide();
  $container.find("input[data-type='dgs-discount-input']").focus().select();
  $(".dgs-cartbar-eventbox-button[data-topnavi='code']").attr("data-status","");
}
function successDiscountCode(content,code){
  $(".dgs-cartbar-item").find(".dgs-cartbar-item-response").attr("data-response","loading").fadeIn();
  var $container		= $("*[data-discount='"+content+"']");
  $container.attr("error",0).find(".dgs-cart-discount-remove").css("display","flex");
  $(".dgs-cartbar-eventbox-button[data-topnavi='code']").attr("data-status","success");
  //document.cookie = "discount_code="+code+"; path=/;";
  $(".dgs-cartbar-button").prop("disabled", true);
  sessionStorage.setItem("currentEventbox","");
  //updateCartContent('sidebar');
  var shopURL		= window.location.protocol + '//' + window.location.hostname;
  var currentURL 	= getCurrentRedirect();
  var currentURL 	= currentURL.replace("&open=cartbar","").replace("?open=cartbar",""); 
  var redirectURL 	= shopURL+"/discount/"+code+"?redirect="+currentURL;
  var open = $("body").attr("data-cartbar");
  if(parseInt(open) == 1){ sessionStorage.setItem("dgs_open","cartbar"); }
  //var redirectURL 	= (currentURL.includes("?")) ?  redirectURL+"&open=cartbar" : redirectURL+"?open=cartbar";
  if(window.location != window.parent.location){ window.parent.location.href = redirectURL; }
  else{ window.location.href = redirectURL; }
}
function loadContent(section_id,target_id,repeat = 1,reaction = 1){
  var modalOpen = $(".dgs-modal").attr("data-open");
  
  $.ajax({type:'GET',url:'/cart.json',dataType:'json',async:true,complete:function(){
    fetch('/?section_id='+section_id).then(response => response.text()).then(function(data){
      if(section_id == "dgs-cart-page"){
        var $button			= $(".dgs-cart-footer-button");
        $button.removeAttr('loadercover').prop("disabled", false);
        $("#"+target_id).empty().hide().html(data).fadeIn(300);
        if(parseInt(modalOpen) == 1){ closeModal(); }
      }else if(section_id == "dgs-cart-sidebar"){ 
        var $button			= $(".dgs-cartbar-button");
        //setTimeout(function(){
        $button.removeAttr('loadercover').prop("disabled", false);
        $("#dgs-cartbar").html(data);
        if(reaction == 1){openCartbar();}
        else{ 
          $("body").attr("data-carttoast",1);openCartToast();
          $(".dgs-cartbar-item").attr("dgs-viewport","true");
          if(parseInt(modalOpen) == 1){ closeModal(); }
        }
        //}, 0);
      }else if(section_id == "dgs-cart-toast"){ 
        $("#"+target_id).empty().html(data);
        $("body").attr("data-carttoast",1);openCartToast();
        if(parseInt(modalOpen) == 1){ closeModal(); }
      }   
      $("*[loadercover]").removeAttr("loadercover").prop("disabled", false);
    });
  }});
}
function buttonMicro(event,elm){
  var cartbarOpen = parseInt($("body").attr("data-cartbar"));
  if(pageType == "product" && cartbarOpen != 1){
    var dataContainer = elm.replace("form-","block-");
  }else if(elm.includes("add2cart-modal")){
    var dataContainer = elm.replace("add2cart-modal-","block-");
  }else{   
    var dataContainer = elm.replace("add2cart-","");      
  }
  $buttons = $("div[data-container='"+dataContainer+"']").find(".dgs-product-buttons");
  $button = $buttons.find(".dgs-product-button.available-details");
  if(event == "over" && $(window).width() >= 1220){
    $button.find("span[text-m]").hide();
    $button.find("span[text-c]").show();
  }else{
    $button.find("span").stop().removeAttr("style");
  }
}
function bindComboClick(){
  $(".dgs-combo[data-open='0'] .dgs-btn").click(function(){
    event.preventDefault();
    var change = $(this).attr("data-change");
    if(change != ""){ $(this).html(change); }
    $(this).parent().attr("data-open",1);
    $(this).parent().find(".dgs-input").focus().select();
    $(this).unbind();
  });
}
function loadercover(selector){ 
  if(!iOS){
    if(selector == "body"){
      $("body").append("<div class='bodyloader' loadercover></div>");
    }else{
      $(selector).attr('loadercover','');
    }
  }
}
function closeloader(){ 
  $(".bodyloader").remove();
  $("*[loadercover]").prop("disabled",false).removeAttr("loadercover");
}

$.fn.isInViewport = function() {
  var distanceTop		= parseInt($(".dgs-header").height()) + 25;
  var elementTop 		= $(this).offset().top;
  var elementBottom 	= elementTop + $(this).outerHeight();
  var viewportTop 		= ($(window).scrollTop() >= distanceTop) ? ($(window).scrollTop() + distanceTop) : $(window).scrollTop();
  var viewportBottom 	= $(window).scrollTop() + ($(window).height() + 25);
  return elementBottom > viewportTop && elementTop < viewportBottom;
};
function checkViewport(){
  $('*[dgs-viewport]').not("[dgs-auto='false']").each(function(){
    if($(this).isInViewport()){
      $(this).attr("dgs-viewport","true");
    }else{
      $(this).attr("dgs-viewport","false");
    }
  });
}
function renderDiscountLine(code,price,discount,quantity,type,percent = 10,layout = "discountLine"){
  //console.log("renderDiscountLine",code,price,discount,quantity,type);
  if (percent == 0) return false;
  var $templateLine 	= $("#"+layout).html();
  var discountSingle	= Number(Math.round((Math.round(discount) / 100) + "e3") + "e-3").toFixed(2);
  if(type == "fixed"){   
    var discountLine 	= $templateLine.replace("[procent]","-"+formatNumber(discountSingle)+"€*");
    var discountMoney 	= discount * quantity;
    var discountSaving	= Number(Math.round((Math.round(discountMoney) / 100) + "e3") + "e-3").toFixed(2);
    var discountLine 	= discountLine.replace("[name]",code);
    var discountLine 	= discountLine.replace("[saving]","(-"+formatNumber(discountSaving)+"€*)");
    var discountPrice 	= parseInt(price) - discountMoney; 
  }else{
    var discountLine 	= $templateLine.replace("[procent]","-"+percent+"%");
    var discountSaving	= discount / 100;
    var discountLine 	= discountLine.replace("[name]",code);
    var discountLine 	= discountLine.replace("[saving]","(-"+formatNumber(discountSaving)+"€*)");
    var discountPrice 	= parseInt(price) - discount;    
  }
  var discountPrice		= Number(Math.round((Math.round(discountPrice) / 100) + "e3") + "e-3").toFixed(2);
  var discountLine 		= discountLine.replace("[price]",formatNumber(discountPrice));
  return discountLine;
}
function discountedPrice(product,tags,price,quantity = 1,output,layout = "discountLine"){
  var currentScriptID		= $("body").attr("script-id");
  var currentScriptID		= (currentScriptID === null) ? "" : currentScriptID;
  //console.log("currentScriptID Function",currentScriptID);
  //console.log("discountedPrice",product,tags,price);
  //console.log("discountScript",discountScript,discountCodes,discountTags,discountProducts,discountTypes,discountValues);
  var discount_cookie 		= getCookie("discount_code");
  if(discount_cookie !== "undefined" && discount_cookie != ""){
    var checkCode 			= checkDiscountCode(discount_cookie);      	
    if(checkCode != false){
      var $productID 		= parseInt(product);
      //var $productTags 		= (tags != "") ? tags.split(",") : tags;
      var $productPrice 	= parseInt(price);
      var quantity 			= parseInt(quantity);
      //console.log("$product",$productID,$productTags,$productPrice);
      var currentScriptKey	= currentScriptID.toString();
      tags = (tags) ? tags : [];
      if(dgsDiscountSpecials30.includes(checkCode.toUpperCase())){ discountPerc = 30; }
      else if(dgsDiscountSpecials25.includes(checkCode.toUpperCase())){ discountPerc = 25; }
      else if(dgsDiscountSpecials20.includes(checkCode.toUpperCase())){ discountPerc = 20; }
      else if(dgsDiscountSpecials15.includes(checkCode.toUpperCase())){ discountPerc = 15; }
      else{ discountPerc = dgsDiscountDefault; }
      if(dgsDiscountScripts.hasOwnProperty(currentScriptKey) && !tags.includes("nodiscount")){
        //console.log("DISCOUNTSCRIPT",dgsDiscountScripts[currentScriptKey]);
        var discountScript 		= dgsDiscountScripts[currentScriptKey];
        var discountCodes 		= discountScript.codes;
        var discountTags 		= discountScript.tags;
        var discountProducts 	= discountScript.products;
        var discountTypes 		= discountScript.types;
        var discountValues 		= discountScript.values;
        //console.log("LENGTH",discountProducts.length,discountCodes.length);
        if(discountProducts.length > 0 && discountProducts.includes($productID)){
          if(discountCodes.length == 0 || (discountCodes.length > 0 && discountCodes.includes(checkCode))){
            var discountKey		= discountProducts.indexOf($productID);
            var discountType	= discountTypes[discountKey];
            //console.log("getKeyByValue",discountProducts,$productID,discountKey);
            if(discountType == "percent"){
              var discountValue	= (parseInt($productPrice) / 100) * parseFloat(discountValues[discountKey]);
            }else{
              var discountValue	= parseFloat(discountValues[discountKey]) * 100;
            }
            //console.log("discountKey",discountKey,discountValue);
            var discountPrice	= parseInt($productPrice) - discountValue;
            var discountText 	= renderDiscountLine(checkCode,$productPrice,discountValue,quantity,discountType,discountValues[discountKey],layout);
            if(discountType == "percent"){
              var discountSaving	= discountValue;
            }else{
              var discountSaving	= discountValue * quantity;
            }
          }else{
            var discountValue	= (parseInt($productPrice) / 100) * discountPerc;
            var discountPrice	= parseInt($productPrice) - discountValue;
            var discountText 	= renderDiscountLine(checkCode,$productPrice,discountValue,quantity,'percent',discountPerc,layout);
            var discountSaving	= discountValue;
          }
        }else{
          var discountValue		= (parseInt($productPrice) / 100) * discountPerc;
          var discountPrice		= parseInt($productPrice) - discountValue;
          var discountText 		= renderDiscountLine(checkCode,$productPrice,discountValue,quantity,'percent',discountPerc,layout);
          var discountSaving	= discountValue;
        }
      }else{
        var discountValue		= (parseInt($productPrice) / 100) * discountPerc;
        var discountPrice		= parseInt($productPrice) - discountValue;
        var discountText 		= renderDiscountLine(checkCode,$productPrice,discountValue,quantity,'percent',discountPerc,layout);
        var discountSaving		= discountValue;
      }   
      if(output == "textline"){ return discountText; }
      else if(output == "saving"){ return parseInt(discountSaving); }
      else{ return parseInt(Math.round(discountPrice)); }
    }else{ return false; }
  }else{ return false; }
}
function configURL(result = "return",type = "add",key = "view",value = ""){
  var currentURL 	= window.location.href;
  var search 		= (window.location.search).toString();
  var oldurl 		= currentURL;
  var newurl 		= currentURL;
  //console.log(window.location,currentURL,search,oldurl,newurl);
  var first 	= (oldurl.includes("?"+key) || search == "") ? true : false;
  var parameter = findGetParameter(key);
  //console.log(parameter,first);
  if(type == "remove"){      
    if(parameter !== null){
      var query = key+"="+parameter;
      var target = (first) ? "?"+query : "&"+query;
      newurl = oldurl.replace(target,"");
    }
  }else if(type == "add" && parameter !== null){
    var oldQuery = key+"="+parameter;
    var oldTarget = (first) ? "?"+oldQuery : "&"+oldQuery;
    var newQuery = key+"="+value;
    var newTarget = (first) ? "?"+newQuery : "&"+newQuery;
    newurl = oldurl.replace(oldTarget,newTarget);
  }else if(type == "add"){
    var newQuery = key+"="+value;
    var first 	= (oldurl.includes("?")) ? true : false;
    var newTarget = (!first) ? "?"+newQuery : "&"+newQuery;
    newurl = oldurl+newTarget;
  }
  var count_con1 = (newurl.match(/\?/g) || []).length;
  var count_con2 = (newurl.match(/\&/g) || []).length;
  if(parseInt(count_con1) == 0 && parseInt(count_con2) >= 1){
    newurl = newurl.replace("&","?");
  }
  if(result == "change"){
    window.history.replaceState({}, null, newurl);
  }else if(result == "reload"){
    window.location.href = newurl;
  }else{ return newurl; }
}
function loadBody(){
  $("body").attr("loaded","");
  timeoutCompleted = setTimeout(function () {
    $("body").attr("completed","");
  }, 500);
}
function loading(){
  /*
    $(window).scrollTop(0);
    $('html,body').scrollTop();
    closeModal();
    closeCartbar();
    $(".dgs-darker").fadeOut();
    $("body").attr("data-sidebar",0);
    $('body').scrollTop(0);
    if(!iOS && !isSafari){$('body').css('overflow', 'hidden');}
    var header = $("header").height();
    var content = $(".dgs-content").height();
    $("[mainloader]").css("height",content+"px)").css("max-height","calc(100vh - "+header+"px)");
    */
  //$(window).scrollTop(0);
  //$('html,body').scrollTop();
  //$('body').scrollTop(0);
  //$("main.dgs-content").attr('loading',''); 
  //closeModal();
  //closeCartbar();
  $("body").attr("data-sidebar",0);
  //$(".dgs-darker").hide();
  $(".dgs-header-logo-img").attr("loadercover","");
}
function openTopnavi(topnavi){
  if(topnavi !== undefined){
    $("aside .dgs-sidebar-content").attr("data-topnavi",topnavi);
  }
}
function closeloading(){ 
  $('body').css('overflow', 'auto');
  $(".dgs-content").removeAttr('loading');
}
function checkImgLoader(direct = 0){
  if($('*[imgloader]:not([imgloading])').length){
    $('*[imgloader]:not([imgloading])').each(function(){
      var img = $(this).attr("img-url");
      if($(this).isInViewport() || direct == 1){
        if(img !== ""){
          var imgWidth = parseInt(parseInt($(this).outerWidth()) * 2);
          if(img.includes("1x1")){
            img = img.replace("1x1",imgWidth+"x"+imgWidth);
          }else if(img.includes("cdn.shopify.com")){
            img = img.replace(".png?v=","_"+imgWidth+"x.png?v=");
            img = img.replace(".jpg?v=","_"+imgWidth+"x.jpg?v=");
            img = img.replace(".jpeg?v=","_"+imgWidth+"x.jpeg?v=");
          }
          //console.log("checkImgLoader",img);
          var imgHash = md5(img);
          console.log("imgHash",imgHash);
          $(this).attr("img-hash",imgHash).attr("imgloading","");
          $('<img/>').attr("img-hash",imgHash).attr('src',img).on('load', function() {          
            var imgLoaded = $(this).attr("src");
            var imgHashLoaded = $(this).attr("img-hash");
            //console.log("imgHashLoaded",imgHashLoaded);          
            $("*[imgloader][img-hash='"+imgHashLoaded+"']")
            .css("background-image","url('"+imgLoaded+"')")
            .removeAttr("img-url").removeAttr("img-hash")
            .removeAttr("imgloader").removeAttr("imgloading");
            $(this).remove();
          });
        }
      }
    });
  }
}
$(window).on('resize scroll',function(){
  checkViewport();
  checkImgLoader();
});
$(window).on('popstate', function() {
  closeloading();
  //console.log("change");
});
$(window).on('beforeunload', function(){
  //if(typeof timeoutLoaded !== "undefined"){clearTimeout(timeoutLoaded);}
  //if(typeof timeoutCompleted !== "undefined"){clearTimeout(timeoutCompleted);}
  //$("body").removeAttr("completed").removeAttr("loaded");
  loading();
});
$(window).on('load', function() {
  closeloading();
  /*
  document.querySelectorAll('lord-icon').forEach(function(el) {
    var stroke = parseFloat(el.getAttribute("data-stroke"));
    var shadow = el.shadowRoot;
    var svg = shadow.querySelectorAll('svg')[0];
    if(typeof svg !== "undefined"){
      svg.querySelectorAll('path[stroke-width]').forEach(function(path) {
        var strokeWidth = path.getAttribute("stroke-width");
        var strokeWidthNew = strokeWidth * stroke;
        //console.log(strokeWidth,strokeWidthNew);
        path.setAttribute("stroke-width",strokeWidthNew);
      });
    }
  });
  */
});
$(document).ready(function(){
  $("body").attr("loaded","");
  if(typeof ttq !== "undefined"){ ttq.track('Browse'); }
  var currentScriptID		= $("body").attr("script-id");
  var currentScriptID		= (currentScriptID === null) ? "" : currentScriptID;
  //console.log("currentScriptID ReadY",currentScriptID);
  var shippingScript		= parseInt(0);
  var shippingScript		= (shippingScript == 1) ? true : false;
  checkViewport();
  checkImgLoader();
  
  getDiscountPrice();
  
  $(".dgs-sidebar-topnavi-item").on("click",function(){
    var topnavi 	= $(this).attr("data-topnavi");
    var index 	= parseInt($(this).attr("data-index"));
    if(topnavi == "home"){
      var homeURL	  	= window.location.protocol + '//' + window.location.hostname;
      if(index != 1){ window.parent.location.href = homeURL; }
    }else{
      openTopnavi(topnavi);
    }
  });
  $(".dgs-sidebar-open").click(function(){
    closeModal();
    closeCartbar();
    $("body").attr("data-sidebar",1);
    $(".dgs-darker").fadeIn();
  });
  $(".dgs-sidebar-close").click(function(){
    $("body").attr("data-sidebar",0);
    $(".dgs-darker").fadeOut();
  });
  $(".dgs-cartbar-close").click(function(){
    closeCartbar();
  });
  $(".dgs-sidebar-toggle").click(function(){
    var sidebar_open = $("body").attr("data-sidebar");
    if(sidebar_open == 1){
      $("body").attr("data-sidebar",0);
      $(".dgs-darker").fadeOut();
    }else{
      closeModal();
      closeCartbar();
      $("body").attr("data-sidebar",1);
      $(".dgs-darker").fadeIn();
    }
  });
  $(".dgs-sidebar-menu").find("li[data-submenu]").click(function(){
    var open = $(this).attr("data-open");
    if(open == 1){
      $(this).attr("data-open",0);
    }else{
      $(this).attr("data-open",1);
      $(this).parent().find("li[data-submenu]").not(this).attr("data-open",0);
    }
  });
  bindComboClick();
  $("a[href!=''][href]").not("[noloader]").not("[target='_blank']")
  .not("[href^='#']").on("click",function(){ loading(); });
  closeloading();
  var sessionStorage_open 	= sessionStorage.getItem("dgs_open");
  var getParameter_open 	= findGetParameter("open");
  if(getParameter_open == "cartbar" || sessionStorage_open == "cartbar"){
    sessionStorage.removeItem("dgs_open");    
    openCartbar();
  }else{ $("#dgs-cartbar").css("transition","0.5s !important"); }
  var getParameter_token	= findGetParameter("token");
  if(!getParameter_token){
    for(var obj in sessionStorage){
      if(sessionStorage.hasOwnProperty(obj) && obj.includes("_token_")){
        sessionStorage.removeItem(obj);
      }
    }
  }
  $(".dgs-carttoast").on("mousedown touchstart",function(){ $(".dgs-carttoast").hide(); });
  $(".dgs-infotoast").on("mousedown touchstart",function(){ closeInfoToast(); });
  if($("#preview-bar-iframe").length){ $("#preview-bar-iframe").hide(); }
  if($("#admin-bar-iframe").length){ $("#admin-bar-iframe").hide(); }
});